import { gql } from '@apollo/client'

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      customer {
        id
        additionalPhones
        birthday
        firstName
        lastName
        phone
        subscribed
        subscribedSms
      }
    }
  }
`
